export default {
  lang: "EN",
};
